<div class="d-flex direction-column">
  <div class="d-flex mb-22 mt-57" *ngIf="appearance === 'legacy'">
    <button
      *ngIf="isAndamento"
      class="btn d-flex justify-center"
      (click)="handlerManageContracts()"
    >
      <app-svg-icon
        src="assets/icons/edit-icon.svg"
        height="20px"
        color="black"
      ></app-svg-icon>
      <span class="btn-description ml-10">Gerenciar contratos</span>
    </button>

    <button class="btn-copy" (click)="exportToClipboard()">
      <app-svg-icon
        class="input-icon"
        width="13px"
        height="13px"
        color="white"
        src="assets/icons/download-icon.svg"
        alt="search"
      >
      </app-svg-icon>
    </button>
  </div>

  <div *ngIf="appearance === 'legacy'">
    <app-header-list
      [headerItems]="headerItems"
      [listContractDetail]="true"
      [appearance]="appearance"
      class="plr-4 pb-5"
    >
    </app-header-list>
    <ng-container *ngFor="let contrato of lot?.Contracts; let i = index">
      <app-cards-contratos-lotes
        [typeDetail]="typeDetail"
        [contract]="contrato"
        [showBeneficiaryName]="true"
        [appearance]="appearance"
      >
      </app-cards-contratos-lotes>
    </ng-container>
  </div>

  <div class="contracts-table" *ngIf="appearance === 'modern'">
    <table>
      <thead>
        <tr>
          <th class="contracts-table__status-col">Status</th>
          <th class="contracts-table__left">Contrato</th>
          <th>Banco</th>
          <th class="contracts-table__right">Valor Financiamento</th>
          <th class="contracts-table__right">Valor Comissão</th>
          <th>Tipo de Operação</th>
          <th class="contracts-table__left">Cliente</th>
          <th>Comissão</th>
          <th>Dt. Produção</th>
          <th>Status</th>
          <th class="contracts-table__action-col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let contrato of lot?.Contracts">
          <td class="contracts-table__status-col">
            <span class="contracts-table__dot" [class.contracts-table__dot--danger]="contractIsCancelled(contrato)"></span>
          </td>
          <td class="contracts-table__left">
            <span class="contracts-table__number-row">
              <span class="contracts-table__strong">{{ contrato.Number }}</span>
              <span *ngIf="contrato.Version !== null && contrato.Version !== undefined" class="contracts-table__version-tag">
                v{{ contrato.Version }}
              </span>
            </span>
            <span class="contracts-table__subline">{{ contrato.QueryNumber }}</span>
          </td>
          <td>{{ contrato.FinancialInstitution | titlecase }}</td>
          <td class="contracts-table__right">{{ contrato.Amount | currency: 'BRL' }}</td>
          <td class="contracts-table__right contracts-table__commission">{{ contrato.InvoiceAmount | currency: 'BRL' }}</td>
          <td>{{ contrato.OperationType || '-' }}</td>
          <td class="contracts-table__left contracts-table__ellipsis" [matTooltip]="(contrato.Client || '') + ' - ' + (contrato.ClientDocument || '')">
            <span class="contracts-table__ellipsis-text">{{ contrato.Client || '-' }}</span>
            <span class="contracts-table__subline">{{ contrato.ClientDocument || '-' }}</span>
          </td>
          <td>{{ contrato.BeneficiaryFee }}%</td>
          <td class="contracts-table__date">{{ contrato.ProductionDate | date: 'dd/MM/yyyy' }}</td>
          <td>
            <app-status-badge
              [label]="contrato.StatusOverride || contrato.Status"
              [tone]="contractStatusTone(contrato)"
              variant="outline">
            </app-status-badge>
          </td>
          <td class="contracts-table__action-col">
            <button type="button" class="contracts-table__view-btn" title="Detalhes do contrato" (click)="openContractDetails(contrato)">
              <app-svg-icon src="assets/icons/view-icon.svg" width="15px" height="15px" color="white"></app-svg-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-container
    *ngIf="
      lot?.Contracts?.length === 0 &&
      (lot?.Reverses?.length === 0 || !lot?.Reverses)
    "
  >
    <div class="contracts-empty empty">
      <span class="empty-message"> Sem contratos disponíveis </span>
    </div>
  </ng-container>
</div>
